import React from 'react';
import { Grid } from '@material-ui/core';

import { RecipeFields } from 'config/recipes';
import { CreateRecipePageSteps } from 'config/routes';

import SinglePageFormStep from './steps/single_form_page/SinglePageFormStep';
import ConfirmationStep from './steps/confirmation/ConfirmationStep';
import RequestStep from './steps/request/RequestStep';
import InvalidStep from './steps/InvalidStep';
import UnauthenticatedStep from './steps/UnauthenticatedStep';

import useCreatePageRecipePage from './useCreateRecipePage';

const CreateRecipePageTitle = 'Recipe creation';

const CreateRecipePage = () => {
  const {
    step,
    recipe,
    setRecipe,
    goToNextStep,
    goToPreviousStep,
    idempotencyToken,
    exitPage,
    isAuthenticated,
  } = useCreatePageRecipePage();

  return (
    <Grid container justify="center">
      <Grid item xs={12} sm={10} md={8}>
        {isAuthenticated && (
          <Stepper
            step={step}
            recipe={recipe}
            setRecipe={setRecipe}
            goToNextStep={goToNextStep}
            goToPreviousStep={goToPreviousStep}
            idempotencyToken={idempotencyToken}
            exitPage={exitPage}
          ></Stepper>
        )}

        {!isAuthenticated && (
          <UnauthenticatedStep
            exitPage={exitPage}
            pageTitle={CreateRecipePageTitle}
          ></UnauthenticatedStep>
        )}
      </Grid>
    </Grid>
  );
};

const Stepper = ({
  step,
  recipe,
  setRecipe,
  goToNextStep,
  goToPreviousStep,
  idempotencyToken,
  exitPage,
}) => {
  if (Object.keys(RecipeFields).includes(step))
    return (
      <SinglePageFormStep
        step={step}
        pageTitle={CreateRecipePageTitle}
        recipe={recipe}
        setRecipe={setRecipe}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
      ></SinglePageFormStep>
    );

  if (step === CreateRecipePageSteps.confirmation)
    return (
      <ConfirmationStep
        recipe={recipe}
        pageTitle={CreateRecipePageTitle}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
      ></ConfirmationStep>
    );

  if (step === CreateRecipePageSteps.request)
    return (
      <RequestStep
        recipe={recipe}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        exitPage={exitPage}
        idempotencyToken={idempotencyToken}
        pageTitle={CreateRecipePageTitle}
      ></RequestStep>
    );

  return <InvalidStep></InvalidStep>;
};

export default CreateRecipePage;
